import { useTranslation } from 'react-i18next'

export const WorkingTimeSettings = () => {
  const { t } = useTranslation()

  return (
    <div className="alert alert-info">
      <p>{t('ComingSoon', 'Tulossa pian')}</p>
    </div>
  )
}
